import React from 'react';
import { CatalogHeaderContainerPc } from '../organisms/catalogHeaderContainerPc';
import { CatalogHeaderContainerSp } from '../organisms/catalogHeaderContainerSp';
import { CatalogFooterContainer } from '../organisms/catalogFooterContainer';
import { CatalogHowtoJpContainer } from '../organisms/catalogHowtoJpContainer';
import { useMedia } from "use-media";
import ScrollToTop from '../../components/atoms/RTCC/scrollToTop';

export const CatalogHowtoJpTemplate = (props) => {


  const isWideHeader = useMedia({ maxWidth: '1000px' });
  return (
    <div className="bodyWrap">
      <ScrollToTop />
      {isWideHeader ? <CatalogHeaderContainerSp path="/rtcc/catalog/home" /> :
        <CatalogHeaderContainerPc path="/rtcc/catalog/home" />}
      <CatalogHowtoJpContainer />
      <CatalogFooterContainer />
    </div>
  )

}
export default CatalogHowtoJpTemplate;